// the order is significant!
import 'prismjs'; //0
import 'prismjs/components/prism-python';//1
